<div *ngIf="control.invalid" class="text-red font-weight-bold mb-4">
    <div *ngIf="control.errors?.['error']">
        {{ control.errors["error"]["message"] }}
    </div>
</div>
